import React, {useEffect, useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {ConfirmDialog, MaterialTable, PageHeader} from "../../components";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import api from "../../common/api";
import Icon from "@material-ui/core/Icon";
import Batch from './components/batch';
import GroupBatch from './components/groupBatch';
import BatchActivate from './components/batchActivate';
import Mobile from "./components/mobile";
import GroupMobile from "./components/groupMobile";
import moment from "moment";
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import red from '@material-ui/core/colors/red';
import { Tooltip } from '@material-ui/core';
import { useGlobalState } from '../../state';
import { updateOnboardingTaskStatus } from '../../common/functions';
import { FarmType } from '../../common/enums';

const useStyles = makeStyles(theme => ({
    root: props=>({
        // margin: props.isDesktop?theme.spacing(4):theme.spacing(1),
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressBar: {
        margin: theme.spacing(2)
    },
    breadcrumbs:{
        marginBottom: theme.spacing(2)
    },
    link: {
        display: 'flex',
    },
    chip: {
        backgroundColor: red[500],
        color: "white",
        fontWeight: 500
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    redChip: {
        justifyContent: 'center',
        fontSize: '0.85rem',
        letterSpacing: '0.5px',
        padding: '4px 8px',
        color: '#f44336',
        backgroundColor: 'rgba(244, 67, 54, 0.08)',
    },
    greenChip: {
        justifyContent: 'center',
        fontSize: '0.85rem',
        letterSpacing: '0.5px',
        padding: '4px 8px',
        color: '#4caf50',
        backgroundColor: 'rgba(76, 175, 80, 0.08)'
    },
    errorMargin:{
        // marginBottom: theme.spacing(3),
    },
    typeLabel:{
        borderRadius:"6px",
        padding:"3px",
        fontWeight:"700",
        marginTop:"5px",
        textAlign:"center"
    },
}));

let currentData = undefined;
let sheds = [];
const Batches = ({showError, showMessage, match}) => {
    const [{user}, dispatch] = useGlobalState();
    const farmID = match.params['farmID'];
    const farmType = user?.farmData?.find(farm => farm.id === parseInt(farmID))?.farmType || 0;

    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({isDesktop});
    const [batches, setBatch] = useState([]);
    const [groupBatches, setGroupBatch] = useState([]);
    //const [sheds, setShed] = useState([]);
    const [breeds, setBreeds] = useState([]);
    const [showBatchDialog, setShowBatchDialog] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showBatchActivateDialog, setShowBatchActivateDialog] = useState(false);
    const [showGroupBatchActivateDialog, setShowGroupBatchActivateDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [showBreedDialog,setBreedDialog] = useState(false)
    const [addBatchError,setAddBatchError] = useState("")
    const [groupErrorMessage, setGroupErrorMessage] = useState('')
    const [showGroupBatchDialog, setShowGroupBatchDialog] = useState(false);
    // eslint-disable-next-line
    const [showGroupBatchView, setShowGroupBatchView] = useState(false);
    const [editMode,setEditmode] = useState(false)
    const [currentGroupBatchData,setCurrentGroupBatchData] = useState({})
    const [groupBachEditMode,setGroupBatchEditMode] = useState(false)
    const [availableSheds,setAvailableSheds]= useState([])
    const [showGroupBatchDeleteConfirm, setGroupBatchShowDeleteConfirm] = useState(false);
    const handleBatchClose = () => {
        currentData = undefined;
        sheds = [];
        setShowBatchDialog(false);
        setShowGroupBatchDialog(false);
        if (errorMessage === "No Breed is Available") {
            setAddBatchError("")
        }
    };

    const addBreedToggle = () => {
        setBreedDialog(true)

    }
    const closeBreedDialog = () => {
        setBreedDialog(false)
    }

    const handleBatchActivateClose = () => {
        currentData = undefined;
        setShowBatchActivateDialog(false);
    };
    const handleGroupBatchActivateClose = () => {
        currentData = undefined;
        setShowGroupBatchActivateDialog(false);
    };

    const onBatchEdit = (batch) => {
        setEditmode(true)
        getAllSheds(batch);
    };


    const onBreedSave = (breed, setpopuploading) => {
        //setLoading(true);
        removeErrorMessage()
        const response = api.post('breed', {
            ...breed
        });

        response.then(res => {
            setBreeds([...breeds, res]);
            setBreedDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Breed not added');
                else
                setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
            setpopuploading(false);
        });
    };
    function onNewBatch(event) {
        setEditmode(false)
        event.preventDefault();
        sheds = [];

        getAllSheds({});
        if (breeds.length === 0) {
            setAddBatchError('No Breed is Available');
        }
        setShowBatchDialog(true);
    }
    // eslint-disable-next-line
    function onNewGroupBatch(event) {
        setGroupBatchEditMode(false)
        getAllShedsForGroupBatch({});
        setCurrentGroupBatchData({})

        if (breeds.length === 0) {
            setAddBatchError('No Breed is Available');
        }
        
    }

    function onGroupBatchEdit(data) {
        let groupBatchID = data?.groupBatchId;
        let rowData = groupBatches.find((groupBatch) => groupBatch.id === groupBatchID);
        let BreedID = rowData?.breedID;
        rowData.breedIndex = breeds.findIndex((breed) => breed.id === BreedID);
        getAllShedsForGroupBatch(rowData)
        setGroupBatchEditMode(true)
        setShowGroupBatchDialog(true)
         setCurrentGroupBatchData(rowData);
    }
    
    const onGroupBatchDelete = (data) => {
        setCurrentGroupBatchData(data)
        setGroupBatchShowDeleteConfirm(true);
    };
    const onDelete = (data) => {
        currentData = data;
        setShowDeleteConfirm(true);
    };

    function handleDeleteConfirmClose() {
        setShowDeleteConfirm(false);
        setGroupBatchShowDeleteConfirm(false)
    }

    const removeErrorMessage = value =>{
        setErrorMessage('');
        setAddBatchError("")
        setGroupErrorMessage("")
    }
    
    const onBatchSave = (batch) => {
        setLoading(true);
        showMessage('');
        const response = api.post(`farm/${farmID}/batch`, {
            ...batch,
            numberOfBirds: parseInt(batch.numberOfBirds, 10),
            isActive:true
        });

        response.then(res => {
            updateOnboardingTaskStatus(user, dispatch, "ADD_BATCHES", farmID);
            
            setBatch([...batches, res]);
            setShowBatchDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Batch not added');
                else if(err.message ===  'Duplicate Key')
                    setErrorMessage('Duplicate Name');
                else
                    setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const onGroupBatchSave = (groupBatch) => {
        setLoading(true);
        showMessage('');
        const response = api.post(`farm/${farmID}/group-batch`, {
            ...groupBatch,
            isGroupBatch:true,
            isActive:true
        });

        response.then(res => {
            setGroupBatch([...groupBatches, res]);
            setShowGroupBatchDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setGroupErrorMessage('Batch not added');
                else if(err.message ===  'Duplicate Key')
                    setGroupErrorMessage('Duplicate Name');
                else
                     setGroupErrorMessage(err.message)
            } else {
                setGroupErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const onBatchUpdate = (batch) => {
        setLoading(true);
        console.debug("On batch update")
        const response = api.post(`farm/${farmID}/batch/${batch.id}`, {
            ...batch,
        });
        response.then(() => {
            let index = batches.findIndex((srcData) => {
                return srcData.id === batch.id;
            });
            batch.oldIsActive = batch.isActive;
            batch.oldShedID = batch.shedID;
            setBatch([...batches.slice(0, index),
                {...batch},
                ...batches.slice(index + 1)]);
            setShowBatchDialog(false);
            setShowBatchActivateDialog(false);
            removeErrorMessage()
        }).catch(err => {
            setShowBatchActivateDialog(true);
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Batch not updated');
                else if(err.message ===  'Duplicate Key')
                    setErrorMessage('Duplicate Name');
                else if(err.message ===  'Given End Date is Greater than Start Date') {
                    setErrorMessage('Given End Date is Greater than Start Date');
                    setShowBatchActivateDialog(false);
                } else if(err.message.includes('Already there is a daily entries for movement data.')) {
                    setErrorMessage(err.message);
                    setShowBatchActivateDialog(false);
                } else setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
            currentData = undefined;
        });
    };

    const onGroupBatchUpdate = (batch) => {
        setLoading(true);
        console.debug("On Group batch update")
        const response = api.post(`farm/${farmID}/group-batch/${batch.id}`, {
            ...batch,
            isGroupBatch:true,
        });
        response.then(() => {
            let index = groupBatches.findIndex((srcData) => srcData.id === batch.id);
            
            if (index !== -1) {
                setGroupBatch([
                    ...groupBatches.slice(0, index),
                    { ...groupBatches[index], ...batch }, // Update the specific item at 'index'
                    ...groupBatches.slice(index + 1)
                ]);
            }
            
            setShowGroupBatchDialog(false);
            removeErrorMessage();
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setGroupErrorMessage('Batch not updated');
                else if(err.message ===  'Duplicate Key')
                    setGroupErrorMessage('Duplicate Name');
                else if(err.message ===  'Given End Date is Greater than Start Date') {
                    setGroupErrorMessage('Given End Date is Greater than Start Date');
                    setShowBatchActivateDialog(false);
                } else if(err.message.includes('Already there is a daily entries for movement data.')) {
                    setGroupErrorMessage(err.message);
                } else {
                    setGroupErrorMessage(err.message)
                }
            } else {
                setGroupErrorMessage('Unknown Error')
            }
            
        }).finally(() => {
            setLoading(false);
            setShowGroupBatchActivateDialog(false)
        });
    };
    const onGroupBatchTransfer = (batch) => {
        setLoading(true);
        console.debug("On Group batch update")
        const response = api.post(`farm/${farmID}/group-batch-transfer/${batch.id}`, {
            ...batch,
            isGroupBatch:true,
            isTransferGroupBatch:true,
        });
        response.then((res) => {
            let index = groupBatches.findIndex((srcData) => srcData.id === batch.id);
            if (index !== -1) {
                let groupBatch = res
                let tempGroupBatches = [...res.transferGroupBatches,...res.groupBatches]
                groupBatch.groupBatches = tempGroupBatches
                groupBatch.transferGroupBatches = []
                setGroupBatch([
                    ...groupBatches.slice(0, index),
                    { ...groupBatches[index], ...groupBatch },
                    ...groupBatches.slice(index + 1)
                ]);
            }
            setShowGroupBatchDialog(false);
            setCurrentGroupBatchData([])
            removeErrorMessage();
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setGroupErrorMessage('Batch not updated');
                else if(err.message ===  'Duplicate Key')
                    setGroupErrorMessage('Duplicate Name');
                else if(err.message ===  'Given End Date is Greater than Start Date') {
                    setGroupErrorMessage('Given End Date is Greater than Start Date');
                    setShowBatchActivateDialog(false);
                } else if(err.message.includes('Already there is a daily entries for movement data.')) {
                    setGroupErrorMessage(err.message);
                } else {
                    setGroupErrorMessage(err.message)
                }
            } else {
                setGroupErrorMessage('Unknown Error')
            }
            
        }).finally(() => {
            setLoading(false);
        });
    };
    
    const onGroupBatchCost = (groupBatch) => {
        setLoading(true);
        const response = api.post(`farm/${farmID}/group-batch-cost/${groupBatch.id}`, {
            ...groupBatch,
            isGroupBatch:true,
        });
        response.then((res) => {
            let index = groupBatches.findIndex((srcData) => srcData.id === groupBatch.id);

            let tempGroupBatch = res
            let breedIndex = breeds.findIndex((breed) => breed.id === tempGroupBatch.breedID);
            tempGroupBatch.breedIndex = breedIndex
            if (index !== -1) {
                setGroupBatch([
                    ...groupBatches.slice(0, index),
                    { ...groupBatches[index], ...tempGroupBatch },
                    ...groupBatches.slice(index + 1)
                ]);
                setCurrentGroupBatchData(tempGroupBatch)
            }
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setGroupErrorMessage('Batch not updated');
                else setGroupErrorMessage(err.message)
            } else {
                setGroupErrorMessage('Unknown Error')
            }
            
        }).finally(() => {
            setLoading(false);
        });
    };
    function onGroupDeleteConfirm (){
        if (currentGroupBatchData && currentGroupBatchData.id) {
            setGroupBatchShowDeleteConfirm(false);
            setLoading(true);
            showError('');
            const response = api.post(`farm/${farmID}/delete-group-batch/${currentGroupBatchData.id}`,{...currentGroupBatchData});

            response.then(res => {
                if (res) {
                    let index = groupBatches?.findIndex((src) => {
                        return src.id === currentGroupBatchData.id;
                    });
                    let newData = [...groupBatches];
                    newData.splice(index, 1);
                    setGroupBatch(newData);
                }
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        setErrorMessage('Batch not Deleted');
                    else
                        setErrorMessage(err.message)
                } else {
                    setErrorMessage('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
               setCurrentGroupBatchData({})
            });

        }
    }
    function onDeleteConfirm (){
        if (currentData && currentData.id) {
            setShowDeleteConfirm(false);
            setLoading(true);
            showError('');
            const response = api.delete(`farm/${farmID}/batch/${currentData.id}`);

            response.then(res => {
                if (res) {
                    let index = batches.findIndex((src) => {
                        return src.id === currentData.id;
                    });
                    let newData = [...batches];
                    newData.splice(index, 1);
                    setBatch(newData);
                }
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        setErrorMessage('Batch not Deleted');
                    else
                        setErrorMessage(err.message)
                } else {
                    setErrorMessage('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
                currentData = undefined;
            });

        }
    }

    
    //Get all Shed API Call
    const getAllSheds = (batch) => {
        setLoading(true);
        showError('');
        showMessage('');
        const response = api.post(`farm/${farmID}/shed_for_batches`,{...batch});

        response.then(res => {
            sheds = [...res];
            currentData = {
                ...batch,
                breedIndex:breeds.findIndex((breed)=>{
                    return breed.id === batch.breedID;}),
                shedIndex:res.findIndex((shed)=>{
                    return shed.id === batch.shedID;})
            };
            setShowBatchDialog(true);

        }).catch(err => {
            if (err.message) {
                console.log(err.message)
            } else {
                console.log('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }

        //Get all Shed API Call
        const getAllShedsForGroupBatch = (batch) => {
            setLoading(true);
            showError('');
            showMessage('');
            const response = api.post(`farm/${farmID}/shed_for_batches`,{...batch});
            response.then(res => {
                let tempshed= [...res]
                setAvailableSheds(tempshed)
                batch = {
                    ...batch,
                    breedIndex:breeds.findIndex((breed)=>{
                        return breed.id === batch.breedID;}),
                    shedIndex:tempshed.findIndex((shed)=>{
                        return shed.id === batch.shedID;})
                };
                setShowGroupBatchDialog(true)
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        setGroupErrorMessage('Batch not updated');
                    else setGroupErrorMessage(err.message)
                } else {
                    setGroupErrorMessage('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
            });
        }

     //Get all Breeds API Call
     const getAllBreeds = () => {
        setLoading(true);
        showError('');
        showMessage('');

        const response = api.get('breed');

        response.then(res => {
            setBreeds([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    console.log(err.message)

                if (err.message === 'No data found'){
                    setAddBatchError('No Breed is Available');
                }
            } else {
                console.log('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    //Get all Batch API Call
    const getAllBatches = () => {
        setLoading(true);
        showError('');
        showMessage('');

        const response = api.get(`farm/${farmID}/batch`);

        response.then(res => {
            setBatch([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('No Batches');
                else
                    setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    //Get all Batch API Call
    const getAllGroupBatches = () => {
        setLoading(true);
        showError('');
        showMessage('');

        const response = api.get(`farm/${farmID}/group-batch`);

        response.then(res => {
            setGroupBatch([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('No Group Batches');
                else
                    setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    const onload=()=>{
        getAllBreeds()
        getAllBatches()
        getAllGroupBatches()
       
    }
    useEffect(onload, []);

    const handleIsActiveChange = (rowData) =>{
        currentData = ({
            ...rowData,
            isActive:!rowData.isActive,
            reactivate:true
        })
        setEditmode(true)
        if (rowData.isActive){
            setShowBatchActivateDialog(true)
        }else{
            onBatchUpdate(currentData)
        }  
    }
    const handleGroupBatchIsActiveChange = (rowData) =>{
        currentData = ({
            ...rowData,
            isActive:!rowData.isActive,
            groupBatches: rowData.isActive 
            ? rowData.groupBatches.map(e => ({ ...e, isActive: false })) 
            : rowData.groupBatches
        })
        setEditmode(true)
        if (rowData.isActive){
            setShowGroupBatchActivateDialog(true)
        }else{
            onGroupBatchUpdate(currentData)
        }  
    }


    const getAgeText = (rowData) => {
        const days = rowData.ageInDays;
        const isEnterpriseBroiler = user?.edition === 1 && farmType === FarmType.BROILER;
        if (isEnterpriseBroiler) {
            return days ? `${days}D` : ''
        }
        let weeks = Math.floor(days / 7);
        let remDays = days % 7;
        let result = "";
        if (remDays === 0 && weeks > 0) {
            weeks--
            remDays = 7
        }
        if (weeks) result += `${weeks}W`;
        if (remDays) result += `${remDays}D`;

        return result
    }

    const onGroupBatchRowEdit = (rowData) => {
        let BreedID = rowData?.breedID;
        rowData.breedIndex = breeds.findIndex((breed) => breed.id === BreedID);
        setCurrentGroupBatchData(rowData);
        getAllShedsForGroupBatch({})
        setGroupBatchEditMode(true)
        setShowGroupBatchDialog(true)
    }

    let batchColumnDefaults = {title: 'Name',field: 'name', defaultSort:'asc'};
    let batchColumn = {...batchColumnDefaults,
        render: rowData => <Mobile data={rowData}
                                   age={farmType === FarmType.BROILER ? undefined : getAgeText(rowData)}
                                   onEdit={()=>{onBatchEdit(rowData)}}
                                   onDelete={()=>{onDelete(rowData)}}
                                   onViewGroupBatch={()=>{onGroupBatchEdit(rowData)}}
                                   handleIsActiveChange={()=>{handleIsActiveChange(rowData)}}
        />,
        // Other columns are hidden on mobile, and material-table skips hidden columns when searching
        customFilterAndSearch: (term, rowData) => {
            const values = [
                rowData.name,
                rowData.shedName,
                rowData.breedName,
                rowData.numberOfBirds,
                moment(rowData.purchaseDate).format("DD-MM-YYYY"),
            ];
            return values.some(value => value !== undefined && value !== null &&
                String(value).toLowerCase().includes(term.toLowerCase()));
        },
    };
    let groupBatchMobileColumn = {
        hidden: isDesktop,
        render: rowData => <GroupMobile data={rowData}
                                   onEdit={()=>{onGroupBatchRowEdit(rowData)}}
                                   onDelete={()=>{onGroupBatchDelete(rowData)}}
                                   handleIsActiveChange={()=>{handleGroupBatchIsActiveChange(rowData)}}
        />,
        // Other columns are hidden on mobile, and material-table skips hidden columns when searching
        customFilterAndSearch: (term, rowData) => {
            const values = [
                rowData.name,
                moment(rowData.purchaseDate).format("DD-MM-YYYY"),
                ...(rowData.groupBatches || []).map(batch => batch.name),
            ];
            return values.some(value => value !== undefined && value !== null &&
                String(value).toLowerCase().includes(term.toLowerCase()));
        },
    };
    let actions = [];
    if (isDesktop) {
        batchColumn = batchColumnDefaults;
        actions = [
            rowData => ({
                icon: () => <Icon color='primary'>edit</Icon>,
                tooltip: 'Edit Batch',
                onClick: (event, rowData) => {
                    onBatchEdit(rowData);
                },
                hidden:!rowData.isActive || rowData.isGroupBatch
            }),
            rowData => ({
                icon: () => <Icon color='error'>delete</Icon>,
                tooltip: 'Delete Batch',
                onClick: (event, rowData) => {
                    onDelete(rowData);
                },
                hidden:!rowData.isActive || rowData.isGroupBatch
            }),
            rowData => ({
                icon: () => <Icon color='primary'>visibility</Icon>,
                tooltip: 'View Group Batch',
                onClick: (event, rowData) => {
                    onGroupBatchEdit(rowData);
                },
                hidden:!rowData.isGroupBatch
            })
        ]
    }

    let groupActions = []
    if (isDesktop) {
        batchColumn = batchColumnDefaults;
        groupActions = [
            rowData => ({
                icon: () => <Icon color='primary'>edit</Icon>,
                tooltip: 'Edit Batch',
                onClick: (event, rowData) => {
                    onGroupBatchRowEdit(rowData)
                }
            }),
            rowData => ({
                icon: () => <Icon color='error'>delete</Icon>,
                tooltip: 'Delete Batch',
                onClick: (event, rowData) => {
                    onGroupBatchDelete(rowData);
                }
            })
        ]
    }
    return (
        <div className={classes.root}>
            <PageHeader
                title='Batches'
                filters={
                    <FormControlLabel
                        label="By Group View"
                        control={
                            <Switch
                                checked={showGroupBatchView}
                                onChange={()=>setShowGroupBatchView(!showGroupBatchView)}
                                color="primary"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        }
                    />
                }
                actions={[
                    { label: 'Add Group Batch', icon: <GroupAddIcon />, onClick: onNewGroupBatch, variant: 'contained', color: 'primary' },
                    { label: 'Add Batch', icon: <AddCircleIcon />, onClick: onNewBatch, variant: 'contained', color: 'primary' },
                ]}
            />
            <div id="error" className={classes.errorMargin}>
                    {errorMessage ? <Chip onDelete={removeErrorMessage} color="primary" label={errorMessage}/> : ''}
             </div>
                {
                    showGroupBatchView ? 

                    <MaterialTable
                    isLoading={loading}
                    columns={[
                        {title: 'id', field: 'id', hidden: true},
                        groupBatchMobileColumn,
                        {...batchColumnDefaults, hidden: !isDesktop},
                        {title: 'Sub Batches', field: 'sheds', hidden: !isDesktop, render:rowData => {
                           return  <div>

                            <Grid container spacing={1}>
                                {rowData?.groupBatches.map((batch, index) => {
                                    return (
                                        <Grid item key={batch.id}>
                                             <Tooltip title={batch.shedName} arrow>

                                                <Chip 
                                                className={classes.typeLabel}
                                                style={{background: "#E8F7F4"}} 
                                                    size="small"
                                                    label={`${batch.name}`} 
                                                />
                                             </Tooltip>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                           </div>
                        }},
                        {title: 'Purchase Date', field: 'purchaseDate', type: 'datetime',
                        editable: 'never',
                        hidden: !isDesktop,
                        render: rowData => {
                            return <span>{moment(rowData.purchaseDate).format("DD-MM-YYYY")}</span>
                        }},
                        {title: 'Active', field: 'isActive',hidden: !isDesktop,
                        cellStyle: {
                            textAlign: 'center'
                          },
                          headerStyle: {
                            textAlign: 'center',
                            paddingLeft: '42px'
                          },
                        render :rowData => {
                            return rowData.groupBatches.some(e => e.isActive)  ? 
                            <Switch
                                checked={rowData.isActive}
                                //disabled={!rowData.isActive}
                                onChange={()=>handleGroupBatchIsActiveChange(rowData)}
                                //value={rowData.isActive}
                                color="primary"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                          :
                            <div style={{ textAlign: "center", minWidth: 'fit-content' }} className={classes.redChip}>Deactivated</div>
                        }}
                    ]}
                    data={groupBatches}
                    options={{
                        actionsColumnIndex: -1,
                        search: true,
                        showTitle: true,
                        
                        toolbar: true,
                        header: isDesktop,
                    }}
                    actions={groupActions}
                    title='Group Batches'
                />   
                    :
                    <MaterialTable
                        isLoading={loading}
                        columns={[
                            {title: 'id', field: 'id', hidden: true},
                            batchColumn,
                            {title: 'Shed', field: 'shedName', hidden: !isDesktop},
                            {title: 'Breed', field: 'breedName', hidden: !isDesktop},
                            {title: 'Number of Birds', field: 'numberOfBirds', hidden: !isDesktop},
                            {title: 'Age', field: 'age', hidden: !isDesktop || farmType === FarmType.BROILER,
                                render: rowData => {
                                return <span>{getAgeText(rowData)}</span>
                            }},
                            {title: 'Purchase Date', field: 'purchaseDate', type: 'datetime',
                            editable: 'never',
                            hidden: !isDesktop,
                            render: rowData => {
                                return <span>{moment(rowData.purchaseDate).format("DD-MM-YYYY")}</span>
                            }},
                            {title: 'Active', field: 'isActive',hidden: !isDesktop,
                            cellStyle: {
                                textAlign: 'center'
                            },
                            headerStyle: {
                                textAlign: 'center',
                                paddingLeft: '42px'
                            },
                            render :rowData => {
                                return rowData.isGroupBatch ?
                                    <div style={{ textAlign: "center", minWidth: 'fit-content' }} className={classes.greenChip}>Group Batch</div>
                                
                               : rowData.isActive ? 
                                <Switch
                                    checked={rowData.isActive}
                                    //disabled={!rowData.isActive}
                                    onChange={()=>handleIsActiveChange(rowData)}
                                    //value={rowData.isActive}
                                    color="primary"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            : rowData.reactivate ?
                                <Switch
                                    checked={rowData.isActive}
                                    //disabled={!rowData.isActive}
                                    onChange={()=>handleIsActiveChange(rowData)}
                                    //value={rowData.isActive}
                                    color="primary"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            :
                                <div style={{ textAlign: "center", minWidth: 'fit-content' }} className={classes.redChip}>Deactivated</div>
                            }}
                        ]}
                        data={batches}
                        options={{
                            actionsColumnIndex: -1,
                            search: true,
                            showTitle: true,
                            
                            toolbar: true,
                            header: isDesktop,
                        }}
                        actions={actions}
                        title='Batches'
                    />   
                }
            <Batch deleteErrorMessage={removeErrorMessage} addBatchError={addBatchError} errorMessage={errorMessage} showDialog={showBatchDialog} handleClose={handleBatchClose} onSave={onBatchSave}
                  onEdit={onBatchUpdate} sheds={sheds} breeds={breeds} loading={loading}
                  editMode={editMode} data={currentData}
                  closeBreedDialog={closeBreedDialog}
                  showBreedDialog={showBreedDialog}
                  onBreedSave={onBreedSave}
                  addBreedDialog={addBreedToggle}
                  isBroiler={farmType === FarmType.BROILER}
                  />

                <GroupBatch deleteErrorMessage={removeErrorMessage} addBatchError={addBatchError} 
                errorMessage={groupErrorMessage} 
                setGroupErrorMessage={setGroupErrorMessage}
                showDialog={showGroupBatchDialog} handleClose={handleBatchClose} 
                onSave={onGroupBatchSave}
                onEdit={onGroupBatchUpdate} sheds={availableSheds} breeds={breeds} loading={loading}
                editMode={groupBachEditMode} data={currentGroupBatchData}
                closeBreedDialog={closeBreedDialog}
                showBreedDialog={showBreedDialog}
                onBreedSave={onBreedSave} 
                addBreedDialog={addBreedToggle}
                onGroupBatchTransfer={onGroupBatchTransfer}
                onGroupBatchCost={onGroupBatchCost}
                  />

            <BatchActivate deleteErrorMessage={removeErrorMessage} errorMessage={errorMessage} showDialog={showBatchActivateDialog} handleClose={handleBatchActivateClose}
                onEdit={onBatchUpdate} sheds={sheds} breeds={breeds} loading={loading}
                editMode={editMode} data={currentData} />


            <BatchActivate deleteErrorMessage={removeErrorMessage} errorMessage={errorMessage} showDialog={showGroupBatchActivateDialog} handleClose={handleGroupBatchActivateClose}
                onEdit={onGroupBatchUpdate} sheds={sheds} breeds={breeds} loading={loading}
                editMode={editMode} data={currentData} />


                <ConfirmDialog showDialog={showGroupBatchDeleteConfirm}
                       handleClose={handleDeleteConfirmClose}
                       onConfirm={onGroupDeleteConfirm}
                       title='Delete Group Batch ?'
                       subText='This action will delete the batch and also sub batches as well'/>
             <ConfirmDialog showDialog={showDeleteConfirm}
                       handleClose={handleDeleteConfirmClose}
                       onConfirm={onDeleteConfirm}
                       title='Delete Batch ?'
                       subText='This action will delete the batch.'/>
        </div>
    );
};

export default Batches;